module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVCAYAAACpF6WWAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH3wIJCCgAezrnogAAATZJREFUOMvVlL1Kw1AUx3/3NmmTNEVEcBDqC6i7ID5GNzsIjnZ1UZxc3QRX0U7N4NQHEPEBHHwBLZ3UYG36QZN7HVoUaaiRpKBnu1+/8/8fzj2i0bjSZBwGQKWykxnQ8+pjKIDvv2QGlswh5gI1kl48tIu05FjDWhRyMOing14WLM4t63PdCQXMgP5ovyUlR7ZDLquaaqDmuHSFYH+Gsl9BLwoWN6bJdjhibzhID32UkmPbwdWas6CLSGtfA7WiSyAEJ/0eZaXSt9SdYXJrmJSVYkkpmmYeX35pfRaSpplnIwpZjUkYCx1O3j9JSdUtTZ0/5HJU3RKnvYDdmFrHQi3NlOUIaE+av6A1y1rjap3c/lY44v7N/7bXlpL1hUUANqOQ6/fOH/37K0rxmnA8/rPR53n1TKEfqSVgP+O1HC4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/images/4.png
// module id = 249
// module chunks = 0